import { IBottomMenuButtonProps } from "@housebets/housebets-x-package/lib/components/layout/Layout/View/components/BottomMenuMobile/Button/types";
import { TFormSelectGroup } from "@housebets/housebets-x-package/lib/components/form/Select/global";
import { CryptoCurrency, FiatCurrency } from "@housebets/housebets-x-package/lib/components/icons";
import { CurrencyType } from "app/types/common";

export const bottomMenu: IBottomMenuButtonProps[] = [
    {
        icon: "casino",
        isActive: false,
        onClick: function Qo() { },
        title: "Rewards",
    },
    {
        icon: "chat",
        isActive: false,
        onClick: function Qo() { },
        title: "Chat",
    },
    {
        icon: "sports",
        isActive: false,
        onClick: function Qo() { },
        title: "Sports",
    },
];

export const currencySelectOptions: TFormSelectGroup[] = [
    {
        id: CurrencyType.Crypto,
        name: "Crypto",
        groupIcon: <CryptoCurrency />,
        options: [],
    },
    {
        id: CurrencyType.Fiat,
        name: "Fiat",
        groupIcon: <FiatCurrency />,
        options: [],
    },
];

interface cryptoFullNameItem {
    symbol: string;
    fullName: string;
}
export const cryptoFullNameList: cryptoFullNameItem[] = [
    { symbol: "BTC", fullName: "Bitcoin (BTC)" },
    { symbol: "ETH", fullName: "Ethereum (ETH)" },
    { symbol: "USDT", fullName: "Tether (USDT)" },
    { symbol: "BNB", fullName: "BNB (BNB)" },
    { symbol: "SOL", fullName: "Solana (SOL)" },
    { symbol: "USDC", fullName: "USDC (USDC)" },
    { symbol: "XRP", fullName: "XRP (XRP)" },
    { symbol: "STETH", fullName: "Lido Staked Ether (STETH)" },
    { symbol: "DOGE", fullName: "Dogecoin (DOGE)" },
    { symbol: "TRX", fullName: "TRON (TRX)" },
    { symbol: "ADA", fullName: "Cardano (ADA)" },
    { symbol: "TON", fullName: "Toncoin (TON)" },
    { symbol: "WSTETH", fullName: "Wrapped stETH (WSTETH)" },
    { symbol: "SHIB", fullName: "Shiba Inu (SHIB)" },
    { symbol: "AVAX", fullName: "Avalanche (AVAX)" },
    { symbol: "WBTC", fullName: "Wrapped Bitcoin (WBTC)" },
    { symbol: "WETH", fullName: "WETH (WETH)" },
    { symbol: "LINK", fullName: "Chainlink (LINK)" },
    { symbol: "BCH", fullName: "Bitcoin Cash (BCH)" },
    { symbol: "DOT", fullName: "Polkadot (DOT)" },
    { symbol: "SUI", fullName: "Sui (SUI)" },
    { symbol: "LEO", fullName: "LEO Token (LEO)" },
    { symbol: "USDS", fullName: "USDS (USDS)" },
    { symbol: "LTC", fullName: "Litecoin (LTC)" },
    { symbol: "NEAR", fullName: "NEAR Protocol (NEAR)" },
    { symbol: "APT", fullName: "Aptos (APT)" },
    { symbol: "UNI", fullName: "Uniswap (UNI)" },
    { symbol: "WEETH", fullName: "Wrapped eETH (WEETH)" },
    { symbol: "PEPE", fullName: "Pepe (PEPE)" },
    { symbol: "ICP", fullName: "Internet Computer (ICP)" },
    { symbol: "TAO", fullName: "Bittensor (TAO)" },
    { symbol: "FET", fullName: "Artificial Superintelligence Alliance (FET)" },
    { symbol: "DAI", fullName: "Dai (DAI)" },
    { symbol: "XMR", fullName: "Monero (XMR)" },
    { symbol: "ETC", fullName: "Ethereum Classic (ETC)" },
    { symbol: "KAS", fullName: "Kaspa (KAS)" },
    { symbol: "XLM", fullName: "Stellar (XLM)" },
    { symbol: "USDE", fullName: "Ethena USDe (USDE)" },
    { symbol: "WBT", fullName: "WhiteBIT Coin (WBT)" },
    { symbol: "STX", fullName: "Stacks (STX)" },
    { symbol: "WIF", fullName: "dogwifhat (WIF)" },
    { symbol: "FDUSD", fullName: "First Digital USD (FDUSD)" },
    { symbol: "POL", fullName: "POL (ex-MATIC) (POL)" },
    { symbol: "OKB", fullName: "OKB (OKB)" },
    { symbol: "AAVE", fullName: "Aave (AAVE)" },
    { symbol: "IMX", fullName: "Immutable (IMX)" },
    { symbol: "ARB", fullName: "Arbitrum (ARB)" },
    { symbol: "FIL", fullName: "Filecoin (FIL)" },
    { symbol: "OP", fullName: "Optimism (OP)" },
    { symbol: "CRO", fullName: "Cronos (CRO)" },
];
